module.exports = __webpack_public_path__ + "static/media/arrows-size.a75125bc.svg";